import { render, staticRenderFns } from "./errList.vue?vue&type=template&id=50121671&scoped=true&"
import script from "./errList.vue?vue&type=script&lang=ts&"
export * from "./errList.vue?vue&type=script&lang=ts&"
import style0 from "./errList.vue?vue&type=style&index=0&id=50121671&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50121671",
  null
  
)

export default component.exports